export class FindDashboardCharts {
  public static readonly type = '[Project/Dashboard/List] FindDashboardCharts';
  constructor(public readonly id: string) {}
}
